import { render, staticRenderFns } from "./pwa_payments.vue?vue&type=template&id=1f57f758&scoped=true&"
import script from "./pwa_payments.vue?vue&type=script&lang=js&"
export * from "./pwa_payments.vue?vue&type=script&lang=js&"
import style0 from "./pwa_payments.vue?vue&type=style&index=0&id=1f57f758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f57f758",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f57f758')) {
      api.createRecord('1f57f758', component.options)
    } else {
      api.reload('1f57f758', component.options)
    }
    module.hot.accept("./pwa_payments.vue?vue&type=template&id=1f57f758&scoped=true&", function () {
      api.rerender('1f57f758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/payments/list/pwa_payments.vue"
export default component.exports